import { IonAvatar, IonLabel, IonModal } from "@ionic/react";
import React from "react";
import { utilService } from "../../../../../../services/utilService";
import "./NursePopup.scss";

interface NursePopupProps {
  showModal: boolean;
  onCancel: () => void;
  nurseData: any;
}

const NursePopup: React.FC<NursePopupProps> = (props) => {
  console.log(props.nurseData);

  return (
    <div>
      <IonModal
        isOpen={props.showModal}
        backdropDismiss={false}
        className="nurse-modal"
      >
        <div className="nurse-container">
          <span className="nurse-heading">Assigned Nurses</span>
          <IonLabel
            className="close icon-close"
            onClick={() => {
              props.onCancel();
            }}
          ></IonLabel>
          <div className="nurse-list">
            {props.nurseData && props.nurseData.length > 0
              ? props.nurseData.map((item: any, index: any) => {
                  return (
                    <div className="nurse-card-wrapper">
                      <div className="profile-pic-div">
                        <IonAvatar className="profile-pic">
                          <img
                            src={`${utilService.getBaseUrl()}${item.image}`}
                            onError={(e) => {
                              e.currentTarget.onerror = null;
                              e.currentTarget.src =
                                "assets/images/defaultProfilePic.png";
                            }}
                            alt="Ionic logo"
                            className="doctor-profile-image"
                          />
                        </IonAvatar>
                      </div>
                      <div className="nurse-details">
                        <div className="nurse-card-name">
                          {item.first_name} {item.last_name}
                        </div>

                        <div className="nurse-card-speciality">
                          {utilService.formatSpeciality(
                            item?.shift_time[0]?.group?.speciality
                          )}
                        </div>
                        <div className="nurse-card-time">
                          {item?.shift_time[0]?.start_time}{" "}
                          {item?.shift_time[0]?.end_time ? "-" : ""}{" "}
                          {item?.shift_time[0]?.end_time}
                        </div>
                      </div>
                    </div>
                  );
                })
              : [<span key={""}></span>]}
          </div>
        </div>
      </IonModal>
    </div>
  );
};
export default NursePopup;
